import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import {ms} from '../../styles/normalizeSize';
import {getColor} from '../../styles/utils';
import {Image} from '../Image';
import {Text} from '../Text';
import {View} from '../View';

const DEFAULT_SIZE = 24;

const flagStyle = css<StyledProps>`
  width: ${p => ms(p.size || DEFAULT_SIZE)};

  /* see the proportions https://flagpedia.net/data/flags/normal/us.png */
  height: ${p => ms((p.size || DEFAULT_SIZE) / 1.9)};
  border-radius: ${p => ms((p.size || DEFAULT_SIZE) / 16)};
`;

export const Flag = styled(Image)<StyledProps>`
  ${flagStyle};

  margin-right: ${ms(10)};
`;

export const FlagPlaceholder = styled(View)<StyledProps>`
  ${flagStyle};

  background-color: ${getColor('background2')};
  align-items: center;
  justify-content: center;
`;

export const FlagPlaceholderText = styled(Text).attrs({
  weight: 'bold',
})<StyledProps>`
  font-size: ${p => ms((p.size || DEFAULT_SIZE) / 2.4)};
  line-height: ${p => ms((p.size || DEFAULT_SIZE) / 1.8)};
  background-color: transparent;
  color: ${getColor('text3')};
`;
